import React from 'react';
import { useSelector } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    }
  }));

const detailsLabels = {
    'id-biblioteca': 'Biblioteca',
    'id-tipo-material': 'Tipo de material',
    'tipo-material': 'Tipo de material',
    'titulo': 'Título',
    'sub-titulo': 'Subtítulo',
    'autor': 'Autor',
    'ano': 'Ano',
    'edicao': 'Edição',
    'registro-sistema': 'Registro no sistema',
    'intervalo-paginas': 'Intervalo de páginas',
    'resumo': 'Resumo',
    'isbn': 'ISBN',
    'issn': 'ISSN',
    'endereco-eletronico': 'Endereço eletrônico',
    'notas-gerais': 'Notas gerais',
    'nota-conteúdo': 'Nota de conteúdo',
    'quantidade': 'Quantidade',
    'assunto': 'Assuntos',
    'local-publicacao': 'Local de publicação',
    'editora': 'Editora',
    'autores-secundarios': 'Autores secundários',
    'serie': 'Série',
    'descricao-fisica': 'Descrição física',
    'notas-locais': 'Notas locais',
    'nota-conteudo': 'Notas de conteúdo',
    'codigo-barras': 'Código de barras',
    'colecao': 'Coleção',
    'localizacao': 'Localização',
}

function ItemDetails(props) {
    const classes = useStyles();
    const itemState = useSelector(state => state.item);
    const item = itemState.item

    delete item['numero-chamada']

    return (
        <Box className={classes.root}>
            <List>
                { Object.keys(item).map((key, i) => {
                    const value = item[key]

                    if(value && !!value.length) {
                        return (
                            <ListItem divider={true} key={i}>
                                <ListItemText primary={detailsLabels[key] || key} secondary={
                                    Array.isArray(value) ? value.map(v => `${v} `) : value} />
                            </ListItem>
                        )
                    }})
                }
            </List>
            <Box display="flex" p={1} justifyContent="center">
                <Button 
                    color="primary" 
                    fullWidth={true}
                    onClick={() => props.history.goBack()}>
                        Voltar
                </Button>
            </Box>
        </Box>
    );
}

export default ItemDetails;